import React from 'react';
// Styles
import styles from './style/drawerHeader.module.css';

function DrawerHeader({ children, img }:{ children: React.ReactNode, img?: boolean }) {
  return (
    <header className={`${styles.container} ${img ? styles.container_hasImg : ''}`}>
      { children }
    </header>
  );
}

DrawerHeader.defaultProps = {
  img: false,
}

export default DrawerHeader;
